/**
 * 如果动态添加了新元素，可以调用 this.$wow.sync() 来同步检测
 *
 * ----------------------------------------------------------------------
 * 可用属性：
 * data-wow-duration：动画时长
 * data-wow-delay：动画延迟时间
 * data-wow-offset：元素的位置露出后距离底部多少像素执行
 * data-wow-iteration：动画执行次数
 *
 * <div class="wowClass animate__animated animate__fadeInUp"
 *      data-wow-duration="1s"
 *      data-wow-delay="0.3s">
 *   内容
 * </div>
 *
 */

// 1、引入并注册全局 wow 实例
import WOW from "wowjs";
let wowInstance = null;

// 2、初始化 wow 实例
const initWow = () => {
  if (wowInstance) return wowInstance;

  wowInstance = new WOW.WOW({
    boxClass: "wowClass", // 需要执行动画的元素的类名
    animateClass: "animate__animated", // animation.css 动画的 class
    offset: 0, // 距离可视区域多少开始执行动画
    mobile: true, // 是否在移动设备上执行动画
    live: true, // 异步加载的内容是否有效
  });

  wowInstance.init();
  return wowInstance;
};

/**
 * <div v-wow="{ animation: 'fadeInUp', duration: '1s', delay: '0.2s', offset: '0', iteration: '3' }">
 *   安徽<span>多点美好</span>智能科技有限公司
 * </div>
 * 
 * wowDOM-常用参数：
 * animation: 动画名称 (fadeInUp, fadeInDown, bounceIn) => Animate.css
 * duration: 动画持续时间 ('1s', '2s')
 * delay: 动画延迟时间 ('0.3s', '0.5s')
 * offset: 触发偏移量 (数字，默认 0)
 * iteration: 动画重复次数 (数字，默认 1)
 * 
 */
// 3、新增 v-wow 自定义指令
export const wowDirective = {
  inserted(el, binding) {
    // 获取当前元素
    initWow();

    // 3.1添加基础动画类
    el.classList.add("wowClass", "animate__animated");

    // 3.2设置动画参数
    const config = binding.value || {};

    // 3.3动画名称（animate__ 前缀）参考 Animate.css
    if (config.animation) {
      el.classList.add(`animate__${config.animation}`);
    }

    // 3.4动画持续时间
    if (config.duration) {
      el.setAttribute("data-wow-duration", config.duration);
    }

    // 3.5动画延迟
    if (config.delay) {
      el.setAttribute("data-wow-delay", config.delay);
    }

    // 3.6触发偏移量
    if (config.offset !== undefined) {
      el.setAttribute("data-wow-offset", config.offset);
    }

    // 3.7重复次数
    if (config.iteration) {
      el.setAttribute("data-wow-iteration", config.iteration);
    }

    // 3.8同步新元素到 WOW 实例（可忽略）
    wowInstance?.sync();
  },

  // 3.9元素更新时执行
  update(el, binding) {
    // 当绑定值发生变化时，重新同步动画
    if (binding.value !== binding.oldValue) {
      wowInstance?.sync();
    }
  },
};

// 4.手动同步 wow动画（在动态添加内容后重新检测动画）
export const syncWow = () => {
  wowInstance?.sync();
};

// 5.注册全局指令和属性
export default {
  install(Vue) {
    Vue.directive("wow", wowDirective);

    Vue.prototype.$wow = {
      sync: syncWow,
    };
  },
};
